<template>
    <div :class="boxMsgStyle">
        <div ref="icon_bot" class="bot-icon" v-if="!isUserSend">
            <img :src="styles.avatarBot" alt="robot" style="max-width:24px;max-height:24px;">
        </div>
        <v-container class="text-box-button pa-0 ma-0" fluid>
            <v-row no-gutters>
                <v-spacer v-if="isUserSend"></v-spacer>
                <v-col xs="12" sm="8" md="5" lg="3" xl="2">
                    <div class="image-box-content">
                        <div class="image-display">
                            <v-img :src="msgImageUrl" @click="showLightBox()" aspect-ratio="1.333" cover/>
                        </div>
                        <div class="img-title-content"
                             :style="customUI"
                             v-if="msgContent!==''"
                             v-html="replaceLinkInTextContent(msgContent)">
                        </div>
                        <buttonReact :message_id="msgId" :user_act="msgReact" v-if="!isUserSend"></buttonReact>
                        <div class="img-button-display" v-if="msgButton.length > 0">
                            <button 
                                    v-for="(b, i) in msgButton"
                                    :key="i"
                                    :style="[
                                        buttonCustomUI,
                                        buttonHovered === b ? buttonCustomUIHover : {}
                                        ]"
                                    @mouseover="changeButtonHovered(b)"
                                    @mouseleave="changeButtonHovered(-1)"
                                    @click="btn_msg_click(b)">
                                {{ b.title }}
                            </button>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import handlerMessage from '../../business/handler_messages'
import handlerData from '../../business/handler_data'
import buttonReact from './react-button.vue'
import BaseBox from "@/components/ChatBoxElement/BaseBox";

export default {
    name    : 'ChatImageBox',
    extends: BaseBox,
    props   : {
        isFirstMsg: false, // to display style
        isLastMsg : false, // to display style
        isUserSend: false, // to display style
        content   : null, // content, button
        msgId     : '',     // message id
        msgReact  : '',
    },
    data() {
        return {
            msgContent   : '',
            msgImageUrl  : '',
            msgButton    : [],
            iconBotCustom: '',
            buttonHovered : -1
        }
    },
    components: {
        buttonReact
    },
    mounted() {
        try {
            this.msgContent  = this.content.title
            this.msgImageUrl = this.content.url
            if (this.content.buttons) {
                // // TODO - check type button / remove type webview
                // for (let i = 0; i < this.content.buttons.length; i++) {
                //     if (this.content.buttons[i].webview) {
                //         // is webview - pass
                //         // TODO - handler webview button
                //     } else {
                //         this.msgButton.push(this.content.buttons[i])
                //     }
                // }
                this.msgButton = this.content.buttons
            } else {
                this.msgButton = []
            }

            this.iconBotCustom = this.$store.state.bot_icon
            if (this.iconBotCustom !== '' && !this.isUserSend) {
                this.$refs.icon_bot.setAttribute('style', 'background-image: url(\'' + decodeURIComponent(this.iconBotCustom) + '\'')
            }

        } catch (e) {
            console.log(e)
        }
    },
    methods : {
        showLightBox() {
            this.$store.dispatch(this.$ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW, {
                data : [
                    {
                        title      : this.msgContent,
                        description: '',
                        src        : this.msgImageUrl
                    }
                ],
                index: 0
            })
        },
        btn_msg_click(btn_detail) {
            // console.log(btn_detail);
            if (btn_detail.payload && btn_detail.payload !== '') {
                let send_msg_content = btn_detail.payload
                if (send_msg_content.indexOf('#') >= 0) {
                    send_msg_content += '#' + btn_detail.title
                } else {
                    send_msg_content += '##' + btn_detail.title
                }

                // console.log(send_msg_content)
                handlerMessage.send_message_to_socket('payload', send_msg_content, this.$store.state.subChannel)

            } else if (btn_detail.url && btn_detail.url !== '') {
                // handler url
                handlerData.clickOpenLink(btn_detail.url)

            } else if (btn_detail.phone_call && btn_detail.phone_call !== '') {

                // phone call
                handlerData.clickCallPhone(btn_detail.phone_call)

            } else if (btn_detail.webview && btn_detail.webview !== "") {
                // handler webview
                if (this.$store.state.componentsMainApp) {
                this.$store.state.componentsMainApp.open_webview('', btn_detail.webview);
                }
            }

        },
        changeButtonHovered(value){
            this.buttonHovered = value
        },
        replaceLinkInTextContent(content) {
            return handlerData.urlify(content)
        }
    },
    computed: {
        boxMsgStyle() {
            let st = 'box-msg'
            if (this.isFirstMsg) {
                st = st + ' first-box-msg'
            }
            if (this.isLastMsg) {
                st = st + ' last-box-msg'
            }
            return st
        },
        msgContentStyle() {
            let st = ''
            if (this.isUserSend) {
                st = 'msg-2'
            } else {
                st = 'msg-1'
            }

            if (this.isLastMsg) {
                st = st + ' ' + st + '-lst-msg'
            }
            return st
        }
    }
}
</script>

<style lang="scss" scoped>
    .image-display {
        border        : 1px solid lightgray;
        border-radius : 5px;
    }
    .bot-icon {
        width           : 40px;
        height          : 50px;
        float           : left;
        background-size : 32px;
    }
    .text-box-button {
        width : calc(100% - 43px);
        float : left;
    }
    .img-title-content {
        width      : 100%;
        padding    : 10px 10px;
        color      : white;
        /* background-color: #64C8CC; */
        border-top : 2px solid white;
        /* border-bottom: 2px solid white; */
        // border-radius: 4px;
        background : #6d9ccb;
        box-shadow : 0px 0px 6px rgba(109, 156, 203, 0.4);
        word-break: break-word;
    }
</style>
